import { getApiInstance } from "./apiCore";

const API = getApiInstance();

function login(params: { email: string; password: string }) {
  return API.post("sessions", params);
}

function logout() {
  return API.delete("sessions").then((res: any) => {
    localStorage.removeItem("moga_user");
    localStorage.removeItem("country");
    return res;
  });
}

function signup(params: {
  name: string;
  email: string;
  phone: string;
  password: string;
}) {
  return API.post("users/register", params);
}

function forgotPassword(params: { email: string }) {
  return API.post("users/forget-password", params);
}

function validateResetToken(token: string) {
  return API.get(`users/validate-reset-token/${token}`);
}

export { login, logout, signup, forgotPassword, validateResetToken };
export default API;
